export default "__VITE_ASSET__BMrtTAI8__"